"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarButtonStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _clickable = require("../../clickable");
var _ToolbarBase = require("../components/ToolbarBase");
var _toolbarTheme = require("./toolbarTheme");
const nonForwardedProps = new Set(["isActive", "isHovered", "isChecked", "toolbarSize"]);
const backgroundColorState = _ref => {
  let {
    isChecked,
    isDisabled,
    isHovered,
    isOpen,
    themeMode,
    renderOn
  } = _ref;
  const state = isChecked ? "checked" : "normal";
  // rest < focus < rest:hover < checked < active < checked:hover < disabled
  if (isDisabled) {
    return _toolbarTheme.toolbarButtonBackgroundTheme[renderOn][state].disabled(themeMode);
  } else if (isOpen) {
    return _toolbarTheme.toolbarButtonBackgroundTheme[renderOn][state].active(themeMode);
  } else if (isHovered) {
    return _toolbarTheme.toolbarButtonBackgroundTheme[renderOn][state].hover(themeMode);
  } else {
    return _toolbarTheme.toolbarButtonBackgroundTheme[renderOn][state].rest(themeMode);
  }
};

// In this case, we basically want the same behavior as the ToolbarButton
// has when omitButtonHoverActiveStyles = false, but we DO still want the
// checked and disabled states.
const backgroundColorStateWithoutHover = _ref2 => {
  let {
    isChecked,
    isDisabled,
    themeMode,
    renderOn
  } = _ref2;
  const state = isChecked ? "checked" : "normal";
  // rest < checked < disabled
  if (isDisabled) {
    return _toolbarTheme.toolbarButtonBackgroundTheme[renderOn][state].disabled(themeMode);
  } else if (isChecked) {
    return _toolbarTheme.toolbarButtonBackgroundTheme[renderOn][state].rest(themeMode);
  } else {
    return _toolbarTheme.toolbarButtonBackgroundTheme[renderOn][state].rest(themeMode);
  }
};
const ToolbarButtonStyled = (0, _styled.default)(_clickable.Clickable, {
  shouldForwardProp: prop => !nonForwardedProps.has(prop)
})`
    --sds--ursa-icons--text-color: currentColor;
    border-radius: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _toolbarTheme.toolbarButtonFocusRingTheme.borderRadius(themeMode);
}}px;
    padding: ${_ref4 => {
  let {
    toolbarSize
  } = _ref4;
  return toolbarSize === "xxSmall" ? 0 : `0 2px`;
}};
    display: flex;
    align-items: center;
    max-width: 100%;
    height: 100%;
    color: ${_ref5 => {
  let {
    isDisabled,
    isChecked,
    renderOn,
    themeMode
  } = _ref5;
  return _toolbarTheme.toolbarButtonTextColorTheme[renderOn][isChecked ? "checked" : "normal"][isDisabled ? "disabled" : "rest"](themeMode);
}};
    // In the toolbar, UX doesn't want to use the pointer cursor for some reason. It's probably
    // because we want to match the behavior of the OS more closely.
    cursor: default;

    ${_ref6 => {
  let {
    themeMode,
    toolbarSize
  } = _ref6;
  if (toolbarSize === "xxSmall") {
    return `
              height: 20px;
              width: 20px;
          `;
  } else if (toolbarSize === "small") {
    return `
                height: 28px;
                min-width: 28px;
                padding-left: 4px;
                padding-right: 2px;
            `;
  } else if (toolbarSize === "medium") {
    return `
                height: 28px;
                min-width: 28px;
                padding-left: 4px;
                padding-right: 2px;
            `;
  } else {
    // toolbarSize is large
    return `
                height: 32px;
                min-width: 32px;
                padding: ${_toolbarTheme.toolbarPaddingTheme.buttonPadding(themeMode)};
            `;
  }
}}

    ${_ref7 => {
  let {
    iconOnly
  } = _ref7;
  if (iconOnly) {
    return `
                padding: 0px;
                justify-content: center;
            `;
  }
}}

    background-color: ${backgroundColorState};
    &:active:not([aria-disabled="true"]) {
        background-color: ${_ref8 => {
  let {
    renderOn,
    isChecked,
    themeMode
  } = _ref8;
  return _toolbarTheme.toolbarButtonBackgroundTheme[renderOn][isChecked ? "checked" : "normal"].active(themeMode);
}};
    }

    &[disabled],
    &[aria-disabled="true"] {
        cursor: not-allowed;
    }

    ${props => `.${_ToolbarBase.OMIT_BACKGROUND_CLASS_NAME} &:not(.more-options-button) {
        background-color: ${backgroundColorStateWithoutHover(props)};
    }`}

    ${_ref9 => {
  let {
    themeMode,
    toolbarSize
  } = _ref9;
  return (0, _createFocusRingStyles.createFocusRingStyles)({
    componentBorderWidth: 0,
    theme: themeMode,
    componentRadius: _toolbarTheme.toolbarButtonFocusRingTheme.borderRadius(themeMode),
    gap: toolbarSize === "xxSmall" ? -2 : _toolbarTheme.toolbarButtonFocusRingTheme.offset(themeMode)
  });
}}
`;
exports.ToolbarButtonStyled = ToolbarButtonStyled;
//# sourceMappingURL=ToolbarButtonStyled.js.map